import { Component, ElementRef, input, output, ViewChild } from '@angular/core';
import { Modal } from 'flowbite';
import { AnimationOptions } from 'ngx-lottie';
import { ITown } from 'src/app/models';
import { LiteralService, UtilsService } from 'src/app/services';
import { ServiceInfoService } from 'src/app/services/service-info/service-info.service';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-export-gtfs',
  templateUrl: './modal-export-gtfs.component.html',
  styleUrl: './modal-export-gtfs.component.scss',
  standalone: false,
})
export class ModalExportGtfsComponent {

  readonly id = input<string>();
  readonly modal = input<Modal>();
  readonly loading = input<boolean>(false);
  readonly loadingPercentage = input<number>(0);
  readonly towns = input<ITown[]>([]);
  readonly selectedTowns = input<ITown[]>([]);
  readonly action = output<number[]>();

  @ViewChild('selectAllCheckbox') selectAllCheckbox: ElementRef;

  public allTowns: any[] = [];
  public selectedTownId: number;
  public services: { id: number; tag: string; name: string; checked: boolean }[] = [];
  public loadingServices = false;

  public images = images;

  public exporting: AnimationOptions = {
    path: '/assets/animations/exporting.json'
  };

  public loadingAnimation: AnimationOptions = {
    path: '/assets/animations/loading.json'
  };

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
    private serviceInfoService: ServiceInfoService,
  ) {}

  ngOnChanges(): void {
    this.allTowns = this.towns().map((town: ITown) => ({
      id: town.id,
      value: town.id,
      label: town.name,
    }));
  }

  async initModal() {
    this.services = [];
    if (this.selectedTowns().length === 1) {
      this.selectedTownId = this.selectedTowns()[0].id!;
      await this.loadServices();
    } else {
      this.selectedTownId = undefined!;
    }
  }

  async changeTown(event: any) {
    this.selectedTownId = event.value;
    this.services = [];
    if (!this.selectedTownId) return;
    await this.loadServices();
  }

  private async loadServices() {
    this.loadingServices = true;
    try {
      const result: any = await this.serviceInfoService.getServiceInfosByTowns([this.selectedTownId]);
      const content = result.content || result;
      this.services = (content as any[]).map((service: any) => ({
        id: service.id,
        tag: service.tag,
        name: service.name,
        checked: true,
      }));
    } finally {
      this.loadingServices = false;
    }
    if (this.selectAllCheckbox) {
      this.selectAllCheckbox.nativeElement.checked = true;
    }
  }

  selectAll(event: any) {
    const checked = event.currentTarget.checked;
    this.services.forEach(s => s.checked = checked);
  }

  clearSelection() {
    this.services.forEach(s => s.checked = false);
    if (this.selectAllCheckbox) {
      this.selectAllCheckbox.nativeElement.checked = false;
    }
  }

  getServiceLabel(service: { tag: string; name: string }): string {
    return service.name ? `${service.tag}: ${service.name}` : service.tag;
  }

  get hasSelectedServices(): boolean {
    return this.services.some(s => s.checked);
  }

  onSubmit() {
    const selectedIds = this.services.filter(s => s.checked).map(s => s.id);
    this.action.emit(selectedIds);
  }
}
